import axios from "axios";
import { JWT_TOKEN_KEY } from "./constants";

let interceptorId: number;

export function setupAxiosAuthInterceptor() {

  interceptorId && axios.interceptors.request.eject(interceptorId);
  interceptorId = axios.interceptors.request.use(
    (request) => {
      request.headers["Authorization"] = `Bearer ${localStorage.getItem(JWT_TOKEN_KEY)}`;
      return request;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
}
